export const formatInitials = (value: string): string => {
  value = value
    .toUpperCase()
    .trim()
    .replace(/[^A-Z]/g, '');

  return `${value.split('').join('. ')}${value.length > 0 ? '.' : ''}`;
};

export const addLeadingZero = (value: string | number): string => {
  return `0${value}`.slice(-2);
};

// TODO: this is a simple example to generate "aria-label" attirubte
// and needs to be replaced with a proper solution that supports
// different "Locale"

export const generatePriceAriaLabel = (price: string, suffix?: string): string => {
  const priceAsArray = price.split(',');
  const amount = Number.parseInt(priceAsArray[0].replaceAll(/[^0-9.]/g, '').replaceAll('.', ''));
  const amountCents = Number.parseInt(priceAsArray[1]);

  return `${amount ? amount + ' euro' : ''}
    ${amount && amountCents ? ' en' : ''}
    ${amountCents ? amountCents + ' cent' : ''}
    ${suffix || ''}`;
};
